declare global {
  interface Window {
    _analyticsLoaded?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer?: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag?: (...args: any[]) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbq?: (...args: any[]) => void;
  }
}

/**
 * Fires `fn` on whichever comes first: first user interaction (pointer/key/scroll)
 * or a long idle timeout. Keeps analytics fully off the LCP/TBT critical path on
 * slow mobile, where `requestIdleCallback` rarely fires during initial load.
 */
const deferLoad = (fn: () => void) => {
  let fired = false;
  const run = () => {
    if (fired) return;
    fired = true;
    cleanup();
    fn();
  };
  const events: Array<keyof WindowEventMap> = ["pointerdown", "keydown", "scroll", "touchstart"];
  const cleanup = () => {
    events.forEach((e) => window.removeEventListener(e, run));
    window.clearTimeout(fallbackTimer);
    if (idleCallbackId !== undefined) {
      (window as Window & { cancelIdleCallback?: (id: number) => void }).cancelIdleCallback?.(idleCallbackId);
    }
  };
  events.forEach((e) => window.addEventListener(e, run, { once: true, passive: true, capture: true }));

  let idleCallbackId: number | undefined;
  const fallbackTimer = window.setTimeout(run, 2000);
  if ("requestIdleCallback" in window) {
    idleCallbackId = window.requestIdleCallback(run, { timeout: 10000 });
  }
};

/** After hydration: load GA/gtag, Meta Pixel, and Microsoft Clarity on first
 *  interaction or long-idle (reduces TBT and keeps them off the LCP path). */
export function scheduleThirdPartyAnalytics(): void {
  if (typeof window === "undefined") return;
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1" || host === "[::1]") {
    return;
  }
  requestAnimationFrame(() => {
    deferLoad(() => {
      if (window._analyticsLoaded) return;
      window._analyticsLoaded = true;

      window.dataLayer = window.dataLayer || [];
      function gtag(...args: unknown[]) {
        window.dataLayer!.push(args);
      }
      window.gtag = gtag;

      const gs = document.createElement("script");
      gs.async = true;
      gs.defer = true;
      gs.src = "https://www.googletagmanager.com/gtag/js?id=G-XXXXXXXXXX";
      document.head.appendChild(gs);
      gtag("js", new Date());
      gtag("config", "G-XXXXXXXXXX");
      gtag("config", "AW-17067733337");

      const meta = document.createElement("script");
      meta.textContent = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '2491560507962316');
fbq('track', 'PageView');`;
      document.head.appendChild(meta);

      const clarity = document.createElement("script");
      clarity.textContent = `(function(c,l,a,r,i,t,y){
c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
t=l.createElement(r);t.async=1;t.defer=1;t.src="https://www.clarity.ms/tag/"+i;
y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "w4z9b0z0ge");`;
      document.head.appendChild(clarity);
    });
  });
}
